var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 17.3333C13.9057 18.0988 14.6363 18.7322 15.4752 19.1906C16.3141 19.6489 17.2418 19.9215 18.1953 19.9898C19.1488 20.0581 20.1059 19.9205 21.0016 19.5864C21.8973 19.2523 22.7106 18.7294 23.3864 18.0533L27.3864 14.0533C28.6008 12.796 29.2728 11.112 29.2576 9.36399C29.2424 7.61601 28.5413 5.94392 27.3052 4.70787C26.0692 3.47182 24.3971 2.77069 22.6491 2.7555C20.9011 2.74031 19.2171 3.41227 17.9598 4.62666L15.6664 6.90666M18.6664 14.6667C18.0938 13.9012 17.3633 13.2678 16.5244 12.8094C15.6855 12.3511 14.7578 12.0785 13.8042 12.0102C12.8507 11.9419 11.8937 12.0795 10.998 12.4136C10.1023 12.7477 9.28896 13.2706 8.61311 13.9467L4.61311 17.9467C3.39872 19.204 2.72676 20.888 2.74195 22.636C2.75714 24.384 3.45827 26.0561 4.69432 27.2921C5.93038 28.5282 7.60246 29.2293 9.35044 29.2445C11.0984 29.2597 12.7824 28.5877 14.0398 27.3733L16.3198 25.0933",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.6ab0b60fd01f4b733e49c2c367e09d7a.svg";
export { ForwardRef as ReactComponent };